module.exports = require('./lib/imageRouterFox');


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-image-optimize-plugin/router.js
// module id = 2
// module chunks = 4